import { ColorEnum } from '@/constants/color'
import { createStyleSheet } from 'react-native-unistyles'

export const stylesheet = createStyleSheet({
    container: {
        width: 250,
        gap: 8,
        borderWidth: 1,
        borderColor: ColorEnum.GRAY_300,
        backgroundColor: ColorEnum.WHITE,
        borderRadius: 8,
        flexDirection: 'row',
        alignItems: 'center',
        variants: {
            state: {
                hovered: {
                    borderColor: ColorEnum.BRICK_700,
                },
                focused: {
                    borderColor: ColorEnum.BRICK_700,
                    boxShadow: `0px 0px 4px 0px ${ColorEnum.BRICK_600}`,
                    shadowOffset: { width: 0, height: 0 },
                    shadowRadius: 4,
                    shadowOpacity: 1,
                    elevation: 4,
                    shadowColor: ColorEnum.BRICK_600,
                },
                error: {
                    borderColor: ColorEnum.BRICK_500,
                },
                disabled: {
                    backgroundColor: ColorEnum.GRAY_200,
                },
            },
        },
    },
    textInput: {
        flex: 1,
        outlineWidth: 0,
        borderWidth: 0,
        backgroundColor: 'transparent',
        paddingVertical: 10,
        paddingHorizontal: 16,
        caretColor: ColorEnum.BLUE_500,
        color: ColorEnum.GRAY_900,
        variants: {
            state: {
                error: {
                    color: ColorEnum.BRICK_500,
                },
                disabled: {
                    color: ColorEnum.GRAY_400,
                },
            },
        },
    },
})
